import React from 'react';
import { bool, oneOf } from 'prop-types';
import * as S from './style';

type ButtonLinkProperties = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  link: boolean;
  size: 'lg' | 'md' | 'sm';
  secondary: boolean;
};

function Button(properties: ButtonLinkProperties) {
  const { link, ...rest } = properties;
  return link ? <S.Link {...rest} /> : <S.Button {...rest} />;
}

Button.propTypes = {
  size: oneOf(['sm', 'md', 'lg']),
  secondary: bool,
  link: bool,
};

Button.defaultProps = {
  size: 'md',
  secondary: false,
  link: false,
};

export default Button;
